import React from 'react';
import styled from 'styled-components';

import { FONT_FAMILY_MAIN, LINKS_COLOR, TEXT_COLOR } from '../../main-app/theme';
import SearchIcon from '../../main-app/images/icon-search.inline.svg';

const SearchInputContainer = styled.div`
  position: relative;
`;

const Input = styled.input`
  height: 42px;
  border-radius: 24px;
  border: solid 1px rgba(0, 0, 0, 0.07);
  background-color: #ffffff;
  padding: 10px 40px 10px 16px;
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  letter-spacing: -0.2px;
  color: ${TEXT_COLOR};
  width: 100%;
  
  &:focus {
    outline: none;
    border: solid 1px rgba(0, 0, 0, 0.1);
  }
`;

const SearchIconContainer = styled.div`
  width: 30px;
  height: 30px;
  background: ${LINKS_COLOR};
  padding: 9px;
  position: absolute;
  top: 6px;
  right: 6px;
  border-radius: 21px;
  line-height: 12px;
`;

const StyledSearchIcon = styled(SearchIcon)`
  fill: #fff;
  width: 12px;
  height: 12px;
`;

const SearchInput = React.forwardRef((props, ref) => ((
  // eslint-disable-next-line react/prop-types
  <SearchInputContainer className={props.className}>
    <Input {...props} ref={ref} />
    <SearchIconContainer>
      <StyledSearchIcon />
    </SearchIconContainer>
  </SearchInputContainer>
)));

export { SearchInput };
